import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ServiceBase, { checkNetworkConnection } from "utils/ServiceBase";
import { useTranslation } from "react-i18next";
import { Modal, notification } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import {
  pushApiErrorData,
  setApiErrorOpen,
  setOpenNoInternetModal,
  setCurrentLanguage,
} from "redux/action";
import CryptoJS from "crypto-js";
import i18n from "i18next";
import ic_flag_vietnamese from "assets/svg/ic_flag_vietnamese.svg";
import ic_flag_english from "assets/svg/ic_flag_english.svg";
import LoginPromptCard from "components/login/LoginPromptCard";
import ModalLogin from "containers/login";
import { toast } from "react-toastify";
import icon_toast_success from "assets/icon_toast_success.png";
import icon_call_staff from "assets/icon_call_staff.png";
import icon_cart from "assets/icon_cart.png";
import icon_app_tgs from "assets/svg/icon_app_tgs.svg";

const consent = localStorage.getItem("cookieConsent");

const TopNavigation = memo(({
  className,
  isSticky,
  isStatic,
  handleNavCart,
  isSimple,
  isDraft,
  onLogoutAccountTgs,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLanguageEnglish = useSelector(
    (state) => state.rootReducer.isLanguageEnglish,
  );
  const isShowBtnDish = useSelector((state) => state.rootReducer.isShowBtnDish);
  const listSession = useSelector((state) => state.rootReducer.listSession);
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");
  const draftHomeBrand = useSelector((state) => state.rootReducer.draftHomeBrand);
  const homeBrand = useSelector((state) => state.rootReducer.homeBrand);
  const orderSuccess = useSelector((state) => state.rootReducer.orderSuccess);
  const infoTgsV3 = useSelector((state) => state.rootReducer.infoTgsV3);
  const cartDetailTotal = useSelector((state) => state.rootReducer.cartDetailTotal);
  const [isEnglish, setEnglish] = useState(isLanguageEnglish);
  const [isModalLoginOpen, setModalLoginOpen] = useState(false);
  const [isShowAccountTgs, setIsShowAccountTgs] = useState(false);
  const [tableData, setTableData] = useState(null);
  const isOrderedPage = location.pathname === "/ordered";
  const sessionsForHeader = useMemo(() => {
    if (orderSuccess?.["lst-session"]?.length > 0) {
      return orderSuccess["lst-session"];
    }
    return listSession || [];
  }, [orderSuccess, listSession]);

  const hasPendingDishToExpedite = useMemo(() => {
    return sessionsForHeader.length > 0;
  }, [sessionsForHeader]);

  const handlePushApiError = (api) => {
    dispatch(pushApiErrorData([api]));
  };

  const handleShowApiErrors = () => {
    notification.close("internalServerError");
    dispatch(setApiErrorOpen(true));
  };
  const getHeaderErrorMessage = (errorMessage) => {
    if (!errorMessage) return t("internalServerError");

    const normalizedMessage = String(errorMessage).trim();
    if (
      normalizedMessage === "Request failed with status code 404" ||
      normalizedMessage === "Request failed with status code 500"
    ) {
      return t("internalServerError");
    }

    return normalizedMessage;
  };
  const showHeaderErrorNotification = (errorMessage) => {
    notification["error"]({
      key: "topNavigationError",
      message: t("errorTitle"),
      description: getHeaderErrorMessage(errorMessage),
      duration: 3,
      placement: "top",
      top: 88,
    });
  };

  const handleCheckNetworkConnect = () => {
    if (checkNetworkConnection()) return true;
    dispatch(setOpenNoInternetModal(true));
    return false;
  };
  const onChangeEnglish = () => {
    if (isEnglish) {
      dispatch(setCurrentLanguage(false));
      localStorage.setItem("currentLanguage", "vie");
      changeLanguage("vie");
      setEnglish(false);
    } else {
      dispatch(setCurrentLanguage(true));
      localStorage.setItem("currentLanguage", "eng");
      changeLanguage("eng");
      setEnglish(true);
    }
  };
  const changeLanguage = (e) => {
    let dim = {};
    if (infoTgsV3 && consent === "accepted") {
      dim = {
        customers: {
          customer_id: CryptoJS.MD5(infoTgsV3?.["cellphone"]).toString(),
          name: infoTgsV3?.["first-name"] + " " + infoTgsV3?.["last-name"],
          email: infoTgsV3?.["email"],
          phone: infoTgsV3?.["cellphone"],
          ggg_user_id: infoTgsV3?.["customer-number"],
        },
        purchase: {
          id: tableData.qrCode,
          name: tableData.qrCode,
        },
      };
    } else {
      dim = {
        purchase: {
          id: tableData.qrCode,
          name: tableData.qrCode,
        },
      };
    }
    window.web_event.track("language", "choose", {
      dims: dim,
      extra: {
        language: e,
        id_restaurant: tableData?.restaurantCode,
        table_number: tableData?.["table-name"],
        customer_id: infoTgsV3
          ? CryptoJS.MD5(infoTgsV3?.["cellphone"]).toString()
          : "",
      },
    });
    i18n.changeLanguage(e);
  };
  const onClickButtonHeader = () => {
    if (isOrderedPage) {
      expediteOrder();
    } else {
      onCallStaff();
    }
  };
  const onCloseModalLogin = () => {
    setModalLoginOpen(false);
  };

  const onShowLogin = () => {
    setIsShowAccountTgs(false);
    setModalLoginOpen(true);
  };

  useEffect(() => {
    if (!location.state?.openAppLogin) return;
    if (infoTgsV3 && !location.state?.appLoginCallbackWarning) return;
    setIsShowAccountTgs(false);
    setModalLoginOpen(true);
  }, [
    infoTgsV3,
    location.state?.appLoginCallbackWarning,
    location.state?.openAppLogin,
  ]);

  const onToggleAccountTgs = () => {
    setIsShowAccountTgs((prev) => !prev);
  };
  const onCloseAccountTgs = () => {
    setIsShowAccountTgs(false);
  };
  const onLogout = () => {
    setIsShowAccountTgs(false);
    onLogoutAccountTgs?.();
  };
  const onSetCurrentLanguageVietnamese = useCallback(() => {
    if (isLanguageEnglish) {
      dispatch(setCurrentLanguage(false));
      localStorage.setItem("currentLanguage", "vie");
      changeLanguage("vie");
      setEnglish(false);
    }
  }, [dispatch, isLanguageEnglish]);

  const onSetCurrentLanguageEnglish = useCallback(() => {
    if (!isLanguageEnglish) {
      dispatch(setCurrentLanguage(true));
      localStorage.setItem("currentLanguage", "eng");
      changeLanguage("eng");
      setEnglish(true);
    }
  }, [dispatch, isLanguageEnglish]);

  const expediteOrder = useCallback(async () => {
    if (!handleCheckNetworkConnect()) return;
    const payload = {
      guid: `{${tableData?.qrCode}}`,
    };

    const url = `/ggg/api/v2.0/qr-order/expedite-order`;
    const response = await ServiceBase.requestJson({
      method: "POST",
      url,
      data: payload,
    });
    if (response?.value?.code === "200") {
      toast.success(
        <div className="font-500 text-black">{t("itemDish")}</div>,
        {
          icon: () => <img src={icon_toast_success} />,
          className: "toast_one_line",
        },
      );
    } else {
      showHeaderErrorNotification(
        response?.value?.mess || response?.value?.message || response?.message,
      );
    }

    if (response?.code === "ECONNABORTED") {
      handlePushApiError({ url, time: Date.now() });
      notification["error"]({
        key: "internalServerError",
        message: t("internalServerError"),
        duration: 15,
        description: (
          <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
            {t("forDev")}
          </span>
        ),
      });
      return;
    }

    if (response?.value?.code !== "200") {
      showHeaderErrorNotification(
        response?.value?.mess || response?.value?.message || response?.message,
      );
    }
  }, [
    location.pathname,
    tableData?.qrCode,
    tableData?.["table-name"],
    orderSuccess?.waiter?.code,
    t,
  ]);

  const onCallStaff = useCallback(async () => {
    if (!handleCheckNetworkConnect()) return;

    navigate("/call-staff");

    const payload = {
      guid: `%7B${tableData?.qrCode}%7D`,
      content: `${t("table")} ${tableData?.["table-name"]} ${t("requireSupported")}`,
      "employee-code": orderSuccess?.waiter?.code,
    };

    const url = `/ggg/api/v2.0/qr-order/create-noti`;
    const response = await ServiceBase.requestJson({
      method: "POST",
      url,
      data: payload,
    });

    if (response?.code === "ECONNABORTED") {
      handlePushApiError({ url, time: Date.now() });
      notification["error"]({
        key: "internalServerError",
        message: t("internalServerError"),
        duration: 15,
        description: (
          <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
            {t("forDev")}
          </span>
        ),
      });
      return;
    }

    if (response?.value?.code && response?.value?.code !== "200") {
      showHeaderErrorNotification(
        response?.value?.mess || response?.value?.message || response?.message,
      );
    }
  }, [
    location.pathname,
    tableData?.qrCode,
    tableData?.["table-name"],
    orderSuccess?.waiter?.code,
    t,
  ]);

  
  useEffect(() => {
    setTableData(isDraft ? draftHomeBrand : homeBrand);    
  }, [draftHomeBrand, homeBrand, isDraft]);
  return (
    <div
      className={`${className} ${isStatic ? "static" : ""} ${isSticky ? "sticky" : ""}`}
    >
      <div className="top-nav-shell">
        <button
          type="button"
          className="brand-wrap"
          onClick={() => navigate("/products")}
        >
          <img
            src={tableData?.["logo-url"] || ""}
            className="brand-logo"
            alt="Logo"
          />
        </button>

        <div className="top-nav-actions">
          {isOrderedPage && isShowBtnDish && hasPendingDishToExpedite && (
            <button
              type="button"
              className="call-pill"
              onClick={() => {
                onClickButtonHeader();
              }}
            >
              {isOrderedPage ? t("invoke") : t("callStaff")}
            </button>
          )}
          {!isOrderedPage && (
            <button
              type="button"
              className="call-pill"
              onClick={() => {
                onClickButtonHeader();
              }}
            >
              <img
                src={icon_call_staff}
                className="icon-call-staff"
                alt="icon call staff"
              />
              {t("callStaff")}
            </button>
          )}
          <div className="table-pill">
            {t("table")} {tableData?.["table-name"]}
          </div>
          {!isSimple && (
            <>
              <div className="relative" onClick={() => handleNavCart?.()}>
                <div className="img-cart flex justify-center items-center">
                  <img src={icon_cart} alt="cart" />
                </div>
                {cartDetailTotal?.totalQuantity > 0 && (
                  <span className="cart-total-product absolute h-4 w-4 flex items-center justify-center">
                    {cartDetailTotal.totalQuantity}
                  </span>
                )}
              </div>
              <button
                onClick={onToggleAccountTgs}
                type="button"
                className="circle-button user-button"
              >
                {infoTgsV3 ? (
                  <img
                    src={infoTgsV3?.avatar || icon_app_tgs}
                    className="user-avatar"
                    alt="Golden Gate account"
                  />
                ) : (
                  <UserOutlined />
                )}
              </button>
            </>
          )}
          <div
            className="flag"
            onClick={() => {
              onChangeEnglish();
            }}
          >
            <img
              src={!isEnglish ? ic_flag_vietnamese : ic_flag_english}
              alt="logo"
            />
          </div>
        </div>
      </div>
      {isShowAccountTgs && (
        <div className="bg-full" onClick={onCloseAccountTgs} />
      )}
      {isShowAccountTgs && (
        <div
          className="change-language-ly"
          style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
        >
          {infoTgsV3 ? (
            <LoginPromptCard
              imageSrc={infoTgsV3?.avatar}
              imageAlt="Golden Gate account"
              title={
                infoTgsV3?.["full-name"] ||
                `${infoTgsV3?.["first-name"] || ""} ${
                  infoTgsV3?.["last-name"] || ""
                }`.trim()
              }
              subtitle={infoTgsV3?.cellphone || ""}
              buttonText={t("logout")}
              onClick={onLogout}
            />
          ) : (
            <LoginPromptCard onClick={onShowLogin} />
          )}
        </div>
      )}
      <Modal
        className={"custom-modal-product modal-product-combo"}
        destroyOnClose
        open={isModalLoginOpen}
        zIndex={1100}
        footer={null}
        centered
        closable={false}
        onCancel={onCloseModalLogin}
      >
        <ModalLogin
          onCancel={onCloseModalLogin}
          onShowModal={() => {}}
          isFromCart={false}
        />
      </Modal>
    </div>
  );
});

export default styled(TopNavigation)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  pointer-events: none;
  transition:
    transform 0.24s ease,
    opacity 0.24s ease;

  &.sticky {
    position: sticky
  }
  &.static {
    position: static
  }
  .flag {
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 999px;
    background: #ef232b;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
  }

  .flag img {
    width: 100%;
    object-fit: cover;
  }

  .top-nav-shell {
    pointer-events: auto;
    min-height: 68px;
    padding: calc(env(safe-area-inset-top, 0px) + 10px) 12px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #ffffff;
    /* border-bottom: 1px solid #ececec;
    box-shadow: 0 6px 18px rgba(26, 26, 26, 0.06); */
    box-sizing: border-box;
  }

  .brand-wrap {
    border: none;
    display: flex;

    &::after {
      content: "";
      display: inline-block;
      margin-left: 12px;
      background-color: #E6E6E6;
      width: 1px;
      height: 36px;
    }
  }

  .brand-logo {
    height: 36px;
    object-fit: contain;
    display: block;
    aspect-ratio: 1 / 1;
  }

  .top-nav-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0;
  }

  .call-pill,
  .table-pill,
  .circle-button {
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .call-pill {
    padding: 7px 12px;
    border-radius: 999px;
    background: #ef232b;
    color: #ffffff;
    font-size: 13px;
    line-height: 16px;
    font-family: "Manrope-Bold", sans-serif;
  }

  .table-pill {
    min-width: 65px;
    max-width: 95px;
    overflow-x: auto;
    white-space: nowrap;
    padding: 8px 12px;
    border-radius: 999px;
    background: #f3f3f3;
    color: #2f2f2f;
    font-size: 13px;
    line-height: 16px;
    font-family: "Manrope-Bold", sans-serif;
    display: flex;
    justify-content: safe center;
  }

  .circle-button {
    width: 32px;
    height: 32px;
    border-radius: 999px;
    font-size: 18px;
    padding: 0;
    line-height: 38px;
    box-sizing: border-box;
  }

  .star-button {
    background: #ef232b;
    color: #ffd74a;
  }

  .user-button {
    background: #f3f3f3;
    color: #1a1a1a;
    overflow: hidden;
  }

  .user-avatar {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .change-language-ly {
    position: fixed;
    right: 14px;
    top: calc(76px + env(safe-area-inset-top, 0px));
    width: 220px;
    background: #ffffff;
    border-radius: 4px;
    z-index: 1101;
    pointer-events: auto;
    overflow: hidden;
  }

  .bg-full {
    position: fixed;
    top: calc(68px + env(safe-area-inset-top, 0px));
    left: 0;
    width: 100%;
    height: 100%;
    background: #1a1a1a;
    opacity: 0.5;
    z-index: 1100;
    pointer-events: auto;
  }

  body.products-top-chrome-hidden & {
    transform: translateY(calc(-100% - env(safe-area-inset-top, 0px)));
    opacity: 0;
    pointer-events: none;
  }
  .icon-call-staff {
    width: 16px;
    margin-right: 6px;
  }
  .img-cart {
    color: #1a1a1a;
    height: 32px;
    width: 32px;
    display: flex;
    font-weight: 700;
    align-items: center;
    border-radius: 999px;
    background: #f2f2f2;

    img {
      width: 16px;
    }
  }
  .cart-total-product {
    background: #e41e26;
    color: white;
    border-radius: 1.5rem;
    font-size: 10px;
    line-height: 14px;
    top: -5px;
    right: -5px;
  }
`;
